export default __webpack_public_path__ + "static/elemente-3@2x-7c7dc62761040b63dad51ef813af0d56.png";